module.exports = new __parcel__URL__("ToBeUpdated.1183bffe.jpeg").toString();